import { MsalService } from './MsalService';

const msalService = new MsalService();
const getMsalInstance = () => msalService.getMsalInstance();

export { getMsalInstance, msalService };
